module.exports = "/static/assets/749e41931a474a1320cf2b153789c67c.gif";